import React, { useState,useEffect } from "react";
import Card from "@albertsons/uds/molecule/Card";
import Table from "@albertsons/uds/molecule/Table";
import Button from "@albertsons/uds/molecule/Button";
import "../InterfacesHistory/InterfacesHistoryTab.css";
import { fetchHistory, TableData } from "../../../utils/historyLogDbApi";
import { historyTableColumns } from "../../../utils/historyTableColumns";
const itemsPerPage = 10;
const LpnandSatHistoryTab: React.FC = () => {
  const [isOpen, setOpen] = useState<boolean>(true);
  const [filteredData, setFilteredData] = useState<TableData[]>([]);
  const [, setLoadDataStatus] = useState<string | null>(null);
   const [currentPage, setCurrentPage] = useState<number>(1);
  const interfaceName = "LPN AND INVENTORY";

 // Load data when tab is opened
  useEffect(() => {
    if (isOpen) {
      handleLoadData();
    }
  }, [isOpen]);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && isOpen) {
        handleLoadData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [isOpen]);
const handleLoadData = async () => {
    try {
      const result = await fetchHistory(interfaceName);

      const uniqueData = Array.from(
        new Map(
          result.map((item) => [
            `${item.sourceProfile}-${item.MA_Dataload_ts_UTC}`,
            item,
          ])
        ).values()
      );

      const sortedResult = uniqueData.sort(
        (a, b) =>
          new Date(b.MA_Dataload_ts_UTC).getTime() -
          new Date(a.MA_Dataload_ts_UTC).getTime()
      );

      setFilteredData(sortedResult);
      setCurrentPage(1); // Reset to first page
      setLoadDataStatus(null);
    } catch (error: any) {
      console.error("Error while fetching data:", error);
      setLoadDataStatus(
        `Error: ${error.response?.data?.message || error.message}`
      );
    }
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <Card
      collapsible
      title="LPN and Satellite Inventory Data Load History"
      isOpen={isOpen}
      onChange={setOpen}
      className="min-w-[600px] mt15"
    >
      <Card.Content>
        <div className="table-scroll-container">
          <div className="mt-2rem">
            <div className="flex-container-button right-align">
              <Button width={140} onClick={handleLoadData}>
                Refresh
              </Button>
            </div>

            {filteredData.length > 0 ? (
              <><Table
                id="InterfacesHistoryTable"
                itemKey={(item) =>
                    `${item.sourceProfile}-${item.MA_Dataload_ts_UTC}`
                  }
                  items={paginatedData}
                  columns={historyTableColumns}
                  noPagination
                />
<div className="row-count-display text-light-text">
  Showing {(currentPage - 1) * itemsPerPage + 1}–
  {Math.min(currentPage * itemsPerPage, filteredData.length)} of{" "}
  {filteredData.length} results
</div>

                {/* Page Number Controls */}
                <div className="pagination-controls mt-2rem flex justify-end gap-1">
                  {Array.from({ length: totalPages }, (_, index) => {
                    const pageNum = index + 1;
                    return (
                      <Button
                        key={pageNum}
                        className={
                          pageNum === currentPage
                            ? "page-button active"
                            : "page-button"
                        }
                        onClick={() => setCurrentPage(pageNum)}
                        
                      >
                        {pageNum}
                      </Button>
                    );
                  })}
                </div>
              </>
            ) : (
              <div
                style={{ textAlign: "center", margin: "2rem 0", color: "#888" }}
              >
                No data available.
              </div>
            )}
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default LpnandSatHistoryTab;
